import TemplateHeader from "components/Header";
import LoadingOverlay from "components/Indicator/LoadingOverlay";
import TemplateSidemenu from "components/Menu/Sidemenu";
import CustomModal from "components/Modal";
import Pagination from "components/Pagination";
import CustomTable from "components/Table";
import TemplateContainerMain from "components/Template";
import PageTitle from "components/Title/PageTitle";
import moment from "moment";
import _ from "lodash";
import { RolesPermission } from "Config";
import { Component } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { Card, CardBody, Col, Row } from "reactstrap";
import { compose } from "redux";
import FilterForm from "./Form";
import ReportAPI from "./action.js";
import { CheckUserRolesPermissons } from "actions/roles";

class ConsolidatedEInvoiceReport extends Component {
	state = {
		filterQuery: "",
	};

	componentDidMount = () => {
		let tempModule = _.find(RolesPermission, {
			moduleID: CheckUserRolesPermissons(this.props.data.ProfileReducer.profile.roles).id,
		});

		if (tempModule && !tempModule.permissions.includes(13)) {
			return this.props.history.push("/");
		}

		this.props.getReport();

		this.props.getEInvoiceMonth();
		this.props.getEInvoiceYear();
	};

	componentDidUpdate = (pp) => {
		const { reportPages, getReport } = this.props;
		const { filterQuery } = this.state;
		if (pp.reportPages !== reportPages) {
			getReport(`${!!filterQuery ? filterQuery : ""}`);
		}
	};

	renderReportTable = () => {
		const { reportList, onLoad } = this.props;
		return (
			<CustomTable
				data={reportList}
				showPagination={false}
				loading={onLoad}
				columnsContent={[
					{
						Header: "Invoice No.",
						accessorKey: "invoice_no",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.invoice_no}</>;
						},
					},
					{
						Header: "Invoice Date",
						accessorKey: "payment_date",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return (
								<>
									{val.payment_date
										? moment(val.payment_date).format("DD/MM/YYYY hh:mm A")
										: "-"}
								</>
							);
						},
					},
					{
						Header: "Invoice Amount",
						accessorKey: "invoice_amount",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.invoice_amount}</>;
						},
					},
					{
						Header: "Invoice Taxable Amount",
						accessorKey: "invoice_taxable_amount",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.invoice_taxable_amount}</>;
						},
					},
					{
						Header: "SST Tax Rate",
						accessorKey: "invoice_rate",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.invoice_rate}</>;
						},
					},
					{
						Header: "Invoice Tax Amount",
						accessorKey: "invoice_tax_amount",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.invoice_tax_amount}</>;
						},
					},
					{
						Header: "Invoice Total Amount",
						accessorKey: "invoice_total_amount",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.invoice_total_amount}</>;
						},
					},
					{
						Header: "Consolidated E-Invoice No.",
						accessorKey: "consolidated_einvoice_no",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.consolidated_einvoice_no}</>;
						},
					},
					{
						Header: "QR Code Link",
						accessorKey: "qr_code",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.qr_code}</>;
						},
					},
					{
						Header: "Validation Date",
						accessorKey: "validation_date",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return (
								<>
									{val.validation_date
										? moment(val.validation_date).format("DD/MM/YYYY hh:mm A")
										: "-"}
								</>
							);
						},
					},
					{
						Header: "LHDN UUID",
						accessorKey: "lhdn_uuid",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.lhdn_uuid}</>;
						},
					},
					{
						Header: "E-Invoice Date",
						accessorKey: "einvoice_datetime",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return (
								<>
									{val.einvoice_datetime
										? moment(val.einvoice_datetime).format("DD/MM/YYYY hh:mm A")
										: "-"}
								</>
							);
						},
					},
					{
						Header: "E-Invoice Month",
						accessorKey: "einvoice_month",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.einvoice_month}</>;
						},
					},
					{
						Header: "E-Invoice Year",
						accessorKey: "einvoice_year",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.einvoice_year}</>;
						},
					},
					{
						Header: "Consolidated Total Amount",
						accessorKey: "total_amount",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.total_amount}</>;
						},
					},
					{
						Header: "Consolidated Taxable Amount",
						accessorKey: "taxable_amount",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.taxable_amount}</>;
						},
					},
					{
						Header: "Consolidated Tax Amount",
						accessorKey: "tax_amount",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.tax_amount}</>;
						},
					},
					{
						Header: "Consolidated Payable Amount",
						accessorKey: "payable_amount",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.payable_amount}</>;
						},
					},
					{
						Header: "Status",
						accessorKey: "status",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.status}</>;
						},
					},
					{
						Header: "Exemption",
						accessorKey: "exemption",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.exemption}</>;
						},
					}
				]}
			/>
		);
	};

	renderFilterModal = () => {
		const { getReport, onChangeHOC, showFilterModal, einvoiceMonthList, einvoiceYearList } =
			this.props;
		const customSetState = (newState) => {
			this.setState(newState);
		};

		const handleSubmit = (filterQuery) => {
			getReport(filterQuery);
			onChangeHOC("filterQuery", filterQuery);
		}

		return (
			<CustomModal
				size={"lg"}
				title="Consolidated E-Invoice Report Filter"
				isOpen={showFilterModal}
				onClose={() => onChangeHOC("showFilterModal", false)}>
				<FilterForm
					onSubmit={handleSubmit}
					onChangeHOC={onChangeHOC}
					handleState={customSetState}
					einvoiceMonthList={einvoiceMonthList}
					einvoiceYearList={einvoiceYearList}
				/>
			</CustomModal>
		);
	};

	render = () => {
		const { onChangeHOC, reportPages, reportCount } = this.props;

		return (
			<>
				<TemplateContainerMain>
					<TemplateHeader
						onClickToggleProfileModal={() => {}}
						history={this.props.history}
						user={this.props.data.ProfileReducer.profile}
					/>
					<div className="app-main">
						<TemplateSidemenu
							userPermissions={this.props.userPermissions}
							user={this.props.user}
							userRole={this.props.userRole}
						/>
						<div className="app-main__outer">
							<div className="app-main__inner">
								<>
									<PageTitle
										heading="Consolidated E-Invoice Report"
										buttons={[
											{
												color: "",
												className: "btn-outline-primary mr-2",
												onClick: () => { this.props.exportReport() },
												content: (
													<>
														<span>Export</span>
													</>
												),
											},
											{
												color: "",
												className: "btn-outline-primary",
												onClick: () => onChangeHOC("showFilterModal", true),
												content: (
													<>
														<span>Filter</span>
													</>
												),
											},
										]}
									/>
									<ReactCSSTransitionGroup
										component="div"
										transitionName="TabsAnimation"
										transitionAppear={true}
										transitionAppearTimeout={0}
										transitionEnter={false}
										transitionLeave={false}>
										<Row>
											<Col md={12} style={{minWidth: 'max-content'}}>
												<Card className="main-card mb-3">
													<CardBody>
														{this.renderReportTable()}
														<Pagination
															pageIndex={reportPages}
															totalCount={reportCount}
															onChangePage={(val) =>
																onChangeHOC("reportPages", val)
															}
														/>
													</CardBody>
												</Card>
											</Col>
										</Row>
									</ReactCSSTransitionGroup>
									{this.renderFilterModal()}
									{this.props.onLoad && <LoadingOverlay />}
								</>
							</div>
						</div>
					</div>
				</TemplateContainerMain>
			</>
		);
	};
}

export default compose(ReportAPI)(ConsolidatedEInvoiceReport);
